
export default {
  name: "cal-basket-banner",
  created() {
    this.$nuxt.$on("addonUpdated", () => {
      this.addonsList = Object.keys(this.$store.state.cartItem.addons);
    });
    this.$nuxt.$on("vaseUpdated", () => {
      this.vase = this.$store.state.cartItem.vase;
    });
    this.$nuxt.$on("cardUpdated", () => {
      this.addonsList = Object.keys(this.$store.state.cartItem.addons);
    });
  },
  computed: {
    productImage() {
      if (
        this.$store.state.cartItem.product?.images &&
        this.$store.state.cartItem.product?.images.length > 0
      ) {
        return this.$store.state.cartItem.product?.images[0];
      } else {
        return this.$store.state.cartItem.product?.image.imageURL;
      }
    },
    productPrice() {
      let price = this.$store.state.cartItem.product?.itemSalesPrice
        ? this.$store.state.cartItem.product?.itemSalesPrice
        : this.$store.state.cartItem.product?.price;

      if (typeof price === "string") {
        return price.replace("$", "");
      } else {
        return price;
      }
    },
  },
  data() {
    return {
      addonsList: Object.keys(this.$store.state.cartItem.addons),
      vase: this.$store.state.cartItem.vase,
      card: this.$store.state.cartItem.card,
    };
  },
  methods: {
    getAddonPrice(price, quantity) {
      return parseInt(Math.round(price)) * parseInt(quantity);
    },
  },
};
